import { useEffect, useState } from "react";
import { Col, Row, Card, CardBody } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { useListParams } from "hooks/useListParams";
import PettyCashBillList from "./PettyCashBillList";

const PettyCashBillsContainer = () => {
  const { params, updateParams, resetParams } = useListParams({ tab: "bill-list" });
  const [activeTab, setActiveTab] = useState(params?.tab || "bill-list");

  const toggleTab = (tab) => {
    resetParams();
    updateParams({ tab });
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    if (params?.tab) toggleTab(params.tab);
  }, [params?.tab]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Petty Cash" breadcrumbItem="Bills" />
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <PettyCashBillList />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PettyCashBillsContainer;